import React from "react";
import NavBar from "../NavBar/NavBar";
/*import './_header.scss';*/

const Header = () => {
    return (
        <>
        <header>
       < NavBar></NavBar>
       </header>
       </>
    )
}

export default Header;